import React from 'react';
import {Button, Table, TableBody, TableHead} from "@mui/material";
import {StyledTableCell, StyledTableRow} from '../common/table/TableStyles';
import TableLoadingMockup from "../common/table/TableLoadingMockup";
import {useNavigate} from "react-router-dom";
import {useGetReconciliationsQuery} from "../../store/rtk-api/reconciliations/reconciliations";
import IsError from "../common/IsError";
import {useAppDispatch, useTypedSelector} from "../../store";
import {getMonthYearFormat, getYearMonthFromDate} from "../common/helper";
import {setUrlParams} from "../../store/month-data/month-data.slice";


type Props = {
    rowsPerPage: number,
}
const mapping = {
    'month': 'Месяц',
    'corresponds': 'Сверенных',
    'all-orders': 'Всего заявок',
    // 'status': 'Статус',
}
const statuses = {
    UNPAID: "сверка",
    PAID: "оплачено",
    DONE: "сдана",
}

const colors = {
    UNPAID: "action",
    PAID: "info",
    DONE: "success",
}

const ReconciliationList: React.FC<Props> = ({rowsPerPage}) => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const {addressId} = useTypedSelector(state => state.header)
    const {data: reconciliations2, isError, isLoading} = useGetReconciliationsQuery(addressId, {
        skip: addressId === null
    })

    const reconciliations = {
        count: 3,
        next: null,
        previous: null,
        results: [
            {
                id: 1,
                month: "2023-01",
                verified: 15,
                total_appointments: 20,
                status: "PAID"
            },
            {
                id: 2,
                month: "2023-02",
                verified: 18,
                total_appointments: 22,
                status: "DONE"
            },
            {
                id: 3,
                month: "2023-03",
                verified: 12,
                total_appointments: 19,
                status: "UNPAID"
            }
        ]
    };


    const goToMonthDataPage = (month:string) => {
        navigate('month-data',{
            state:{month:getYearMonthFromDate(month).join(' ')}
        })
        dispatch(setUrlParams({date:getMonthYearFormat(month)}))
    }


    return (
        <>
            <IsError isError={isError}/>
            <Table>
                <TableHead>
                    <StyledTableRow>
                        {Object.values(mapping).map((title, idx) => {
                            return (
                                <StyledTableCell key={title} align={"left"}>{title}</StyledTableCell>
                            )
                        })}
                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    {isLoading ?
                        <TableLoadingMockup cellCount={6} rowCount={rowsPerPage}/>
                        :
                        reconciliations?.results?.map((item, ind) => (
                            <StyledTableRow key={item.id}>
                                <StyledTableCell>
                                    <Button
                                        onClick={() => goToMonthDataPage(item.month)}
                                        sx={{
                                        color: "#5BA0CE",
                                        textDecoration: "underline",
                                        textTransform: "capitalize"
                                    }}
                                    >{getYearMonthFromDate(item.month).join(' ')}
                                    </Button>
                                    {/*{item.month}*/}
                                </StyledTableCell>
                                <StyledTableCell>{item.verified}</StyledTableCell>
                                <StyledTableCell>{item.total_appointments}</StyledTableCell>
                                {/*<StyledTableCell>*/}
                                {/*    <Box sx={{*/}
                                {/*        display: "flex", alignItems: "center", gap: "10px"*/}
                                {/*    }}>*/}
                                {/*        /!*@ts-ignore*!/*/}
                                {/*        <CircleIcon color={colors[`${item.status}`]} fontSize={"small"}/>*/}
                                {/*        {statuses[`${item.status}`]}*/}
                                {/*    </Box>*/}

                                {/*</StyledTableCell>*/}
                            </StyledTableRow>
                        ))}
                </TableBody>
            </Table>
            {reconciliations?.results.length === 0 && <div style={{padding: "10px"}}>Данных пока нет...</div>}
        </>
    );
};

export default ReconciliationList;
